import * as React from 'react'
import { RiskChallenge } from '@doordash/component-risk'
import UpdatePhoneNumber from './UpdatePhoneNumber'
import VerifyPhoneNumber from './VerifyPhoneNumber'

import { Mode } from './types'
import { Channel } from '../../../models/types'

const PhoneVerify: React.FC = () => {
  const [mode, setMode] = React.useState<Mode>(Mode.Default)
  const [channel, setChannel] = React.useState<string>(Channel.Sms)

  const commonProps = { setMode, setChannel }

  return (
    <React.Fragment>
      <RiskChallenge channel={channel} blockChannelSwitch />
      {mode === Mode.UpdatePhone ? (
        <UpdatePhoneNumber {...commonProps} />
      ) : (
        <VerifyPhoneNumber {...commonProps} />
      )}
    </React.Fragment>
  )
}

export default PhoneVerify
